import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = [
    {
      title: '热门分类',
      links: [
        { label: '娱乐八卦', href: '/category/entertainment' },
        { label: '社会热点', href: '/category/social' },
        { label: '明星黑料', href: '/category/celebrity' },
        { label: '网红资讯', href: '/category/internet' },
        { label: '丑闻曝光', href: '/category/scandal' },
        { label: '独家爆料', href: '/category/exclusive' },
      ],
    },
    {
      title: '关于网站',
      links: [
        { label: '关于我们', href: '/about' },
        { label: '网站声明', href: '/about#disclaimer' },
        { label: '隐私政策', href: '/about#privacy' },
        { label: '联系我们', href: '/about#contact' },
        { label: '投稿须知', href: '/about#submit' },
      ],
    },
    {
      title: '快速导航',
      links: [
        { label: '首页', href: '/' },
        { label: '热门爆料', href: '/category/entertainment' },
        { label: '最新视频', href: '/category/internet' },
        { label: '热搜排行', href: '/category/social' },
        { label: 'RSS订阅', href: '#' },
      ],
    },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200" role="contentinfo">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-4 space-y-6">
            <Link to="/" className="inline-flex items-center gap-2 text-foreground-900 font-bold text-xl">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-water-flash-line" />
              </span>
              <span>91吃瓜网</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-sm">
              91吃瓜网是国内领先的八卦爆料资讯平台，每日更新最新娱乐圈内幕、明星黑料、社会热点，为网友提供最新鲜、最真实的吃瓜体验。
            </p>
            <div className="flex items-center gap-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-qq-line" />
              </span>
            </div>
          </div>

          {/* Links Columns */}
          <div className="lg:col-span-5 grid grid-cols-3 gap-6">
            {footerLinks.map((section) => (
              <div key={section.title}>
                <h3 className="text-sm font-semibold text-foreground-900 mb-4">{section.title}</h3>
                <ul className="space-y-2.5">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Newsletter */}
          <div className="lg:col-span-3">
            <h3 className="text-sm font-semibold text-foreground-900 mb-4">订阅快讯</h3>
            <p className="text-sm text-foreground-500 mb-4">订阅获取每日最新爆料推送</p>
            <form className="space-y-3" onSubmit={(e) => e.preventDefault()}>
              <div>
                <label htmlFor="footer-email" className="sr-only">邮箱地址</label>
                <input
                  id="footer-email"
                  type="email"
                  name="email"
                  placeholder="输入您的邮箱"
                  className="w-full bg-background-50 border border-background-300 rounded-lg px-4 py-2.5 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300"
                />
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="absolute opacity-0 w-0 h-0"
                value=""
                onChange={() => {}}
              />
              <button
                type="submit"
                className="w-full bg-primary-500 text-background-50 rounded-lg px-4 py-2.5 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                立即订阅
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            © 2026 91吃瓜网 版权所有 | 仅供娱乐参考，部分内容来源于网络
          </p>
          <div className="flex items-center gap-6 text-xs text-foreground-400">
            <Link to="/about" className="hover:text-foreground-600 transition-colors">免责声明</Link>
            <Link to="/about" className="hover:text-foreground-600 transition-colors">隐私政策</Link>
            <Link to="/about" className="hover:text-foreground-600 transition-colors">用户协议</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}